import type { MouseEvent } from 'react';

/**
 * TEC-512 editorial-rail redesign: a dynamic per-company hex color can't be expressed as a
 * Tailwind `hover:text-[...]` utility (Tailwind's JIT scanner needs the class literally present
 * in source, not built from a runtime variable), so hover-only brand-color links use the same
 * onMouseEnter/onMouseLeave inline-style pattern OverviewSectionHeader.tsx's save-button already
 * establishes for this exact problem. Returns {} (no-op) when no color is given, so a caller can
 * always spread this alongside a static `hover:text-jc-accent` Tailwind class used as the
 * fallback for when brandColor is unavailable.
 */
export function brandLinkHoverHandlers(color?: string): {
  onMouseEnter?: (e: MouseEvent<HTMLElement>) => void;
  onMouseLeave?: (e: MouseEvent<HTMLElement>) => void;
} {
  if (!color) return {};
  return {
    onMouseEnter: (e: MouseEvent<HTMLElement>) => {
      e.currentTarget.style.color = color;
    },
    onMouseLeave: (e: MouseEvent<HTMLElement>) => {
      e.currentTarget.style.color = '';
    },
  };
}
